import { CompetencyMapQuery } from "@generated/graphql";
import { CheckOutlined, CloseOutlined, EditOutlined, WysiwygOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { IconButton, Stack, Tooltip } from "@mui/material";
import useIsCreate from "hooks/useIsCreate";
import useCompetencyMapController from "pages/CompetencyMaps/view/components/Header/components/useController";
import { Dispatch, SetStateAction, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { ConstructorTabContext } from "../context";
import { CompetencyMapInputs } from "./types";

type ActionButtonsProps = {
  competencyMap: CompetencyMapQuery["competencyMap"];
  isEditable: boolean;
  setIsEditable: Dispatch<SetStateAction<boolean>>;
  disabled: boolean;
  navigationOpen: boolean;
  setNavigationOpen: Dispatch<SetStateAction<boolean>>;
};

const ActionButtons = ({
  competencyMap,
  isEditable,
  setIsEditable,
  disabled,
  navigationOpen,
  setNavigationOpen,
}: ActionButtonsProps) => {
  const isCreate = useIsCreate();
  const { selectionMode } = useContext(ConstructorTabContext);
  const { handleSubmit } = useFormContext<CompetencyMapInputs>();

  const { onSubmit, onError, loading, knowledgeBlockLoading, skillLoading } = useCompetencyMapController({
    competencyMap,
    isCreate,
    setIsEditable,
  });
  const isSaveLoading = loading || knowledgeBlockLoading || skillLoading;

  return (
    <Stack
      spacing={1}
      sx={{ position: "absolute", top: 40, left: -55 }}>
      <Tooltip title='Навигация'>
        <IconButton onClick={() => setNavigationOpen(!navigationOpen)}>
          <WysiwygOutlined
            fontSize='large'
            color={navigationOpen ? "primary" : "inherit"}
          />
        </IconButton>
      </Tooltip>
      {!isEditable ? (
        <Tooltip title={selectionMode ? "Выйдите из режима выбора" : "Редактировать карту"}>
          <span>
            <IconButton
              onClick={() => setIsEditable(true)}
              disabled={disabled || selectionMode}>
              <EditOutlined fontSize='large' />
            </IconButton>
          </span>
        </Tooltip>
      ) : (
        <>
          {!isCreate && (
            <Tooltip title='Сохранить карту'>
              <span>
                <LoadingButton
                  onClick={handleSubmit(onSubmit, onError)}
                  loading={isSaveLoading}
                  disabled={disabled}
                  sx={{
                    minWidth: "auto",
                    p: 1,
                    borderRadius: "50%",
                  }}>
                  <CheckOutlined fontSize='large' />
                </LoadingButton>
              </span>
            </Tooltip>
          )}
          {!isCreate && (
            <Tooltip title='Отменить'>
              <IconButton onClick={() => setIsEditable(false)}>
                <CloseOutlined fontSize='large' />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </Stack>
  );
};

export default ActionButtons;
